import {apiMethod, APIService} from 'services/APIService';

export class CabinetVisitsAPI extends APIService {
  record = apiMethod((source: string) => this.fetcher.request({
    method: 'POST',
    url: '/api/cabinet-visits/',
    data: {source},
  }));
}
